<template>
  <el-dialog :width=dialog.width title="文件信息" :visible.sync="dialog.show">
    <div>
      <el-table :data="table" ref="table" row-key="id" height="500px" :border="false" :stripe="false">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column label="序号" type="index" width="70" align="center"></el-table-column>
        <el-table-column prop="name" label="文件名称"></el-table-column>
        <el-table-column label="缩略图" width="120" align="center">
          <template slot-scope="scope">
            <!-- 使用 el-image 来显示缩略图 -->
            <el-image v-if="isImage(scope.row.url)" :src="scope.row.url" fit="contain" style="width: 80px;height: 60px;"
              alt="文件缩略图">
            </el-image>
            <span v-else>非图片文件</span>
          </template>
        </el-table-column>
        <el-table-column width="280" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" title="查看" @click="$refs.preview.show(scope.row.url)" plain
              icon="el-icon-view"></el-button>
            <!-- <el-button size="mini" title="删除" @click="del(scope.row)" plain icon="el-icon-delete"></el-button> -->
            <el-button size="mini" title="上移" @click="up(scope)" plain icon="el-icon-arrow-up"></el-button>
            <el-button size="mini" title="下移" @click="down(scope)" plain icon="el-icon-arrow-down"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <my-preview ref="preview"></my-preview>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialog.show = false">关 闭</el-button>
      <el-upload style="display:inline;margin-left:10px" slot="append" :accept="accept" :action="$axios.defaults.baseURL + '/Api/Upload'" :on-success="save" :headers="headers">
        <!-- <el-button type="primary" icon="el-icon-upload">选择文件</el-button> -->
      </el-upload>
    </div>
  </el-dialog>
</template>
<script>

export default {
  props: {
    count: {},
    accept: {},
  },
  data() {
    return {
      table: [],
      groupid: "",
      headers: { token: localStorage.getItem("token") },
      dialog: { show: false, width: "900px", url: "" },
    };
  },
  methods: {
    isImage(url) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp'];
      return imageExtensions.some(ext => url.toLowerCase().endsWith(ext));
    },
    show(groupid) {
      if (!groupid) {
        this.$message.error("请先点击确认按钮，再重新打开本页面上传本项信息。");
        return;
      }
      this.groupid = groupid;
      this.list();
      this.dialog.show = true;
    },

    //删除一个对象
    del(obj) {
      this.$confirm("此操作将删除当前项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        obj["deltime"] = new Date();
        this.$axios.post("/Basic/SaveFile", obj).then((res) => {
          if (res.data.code === 200) this.list();
          else this.$message.error(res.data.msg);
        });
      })
    },

    //上移一个对象
    up(scope) {
      if (scope.$index === 0) return;
      let now = this.table[scope.$index];
      // console.log(now);
      let up = this.table[scope.$index - 1];
      let temp = up['sortid'];
      up['sortid'] = now['sortid'];
      now['sortid'] = temp;
      this.$axios.post("/Basic/SaveFile", now).then((res) => {
        if (res.data.code === 200) {
          this.$axios.post("/Basic/SaveFile", up).then((res) => {
            if (res.data.code === 200) this.list();
            else this.$message.error(res.data.msg);
          });
        } else this.$message.error(res.data.msg)
      });
    },

    //下移一个对象
    down(scope) {
      if (scope.$index === this.table.length - 1) return;
      let now = this.table[scope.$index];
      let down = this.table[scope.$index + 1];
      let temp = down['sortid'];
      down['sortid'] = now['sortid'];
      now['sortid'] = temp;
      this.$axios.post("/Basic/SaveFile", now).then((res) => {
        if (res.data.code === 200) {
          this.$axios.post("/Basic/SaveFile", down).then((res) => {
            if (res.data.code === 200) this.list();
            else this.$message.error(res.data.msg)
          });
        } else this.$message.error(res.data.msg)
      });
    },

    save(res, file) {
      if (res.code === 200) {
        var obj = { name: file.name, url: res.data, groupid: this.groupid };
        this.$axios.post("/Basic/SaveFile", obj).then((res) => {
          if (res.data.code === 200) {
            this.$message.success("上传成功。");
            this.$forceUpdate();
            this.list();
          } else this.$message.error(res.data.msg)
        });
      } else this.$message.error(res.msg);
    },

    list() {
      this.$axios.get("/Basic/ListFile?groupid=" + this.groupid).then(res => {
        this.table = res.data.data;
        this.$parent.myValue = this.table.length;
      })
    },
  }
}
</script>